<button *ngIf="config != null" (click)="click()" [class]="config.styling != null ? config.styling : 'btn btn-primary'">{{config.text}}</button>
